module.exports = __webpack_public_path__ + "img/1 (9).b1eb1394.png";